// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010434/js/" + chunkId + "." + {"44":"b0bc6ca8","225":"34bccbef","481":"14812ff1","486":"c26768f9","770":"b13ed8f8"}[chunkId] + ".0.7909252384251249.chunk.js";
};